﻿window.cObjetComEmailEnvoiMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetTableUpdateLib = function () { return ["com_email_envoi"] }

    this.mGetLibBase = function () { return "Email"; }
    this.mGetAttributBase = function () { return "l'" }
    this.mGetNewLib = function () { return "Nouvel email"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data != 'undefined') { txt = ((objet.data.objet) ? objet.data.objet : "(aucun objet)") }
        else {
            txt = "email"
        }
        if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        var $Icone = null;
        var toolTip = "Email envoyé"
        if (typeof dataTemplate == 'undefined') { $Icone = $("<i class='fas fa-envelope'></i>"); }
        else {
            //var typeICone = "envelope-open-text"
            //if (dataTemplate.presentation_mailing == "1") typeICone = "square-envelope"
            //if (dataTemplate.id_type_classement == 7) {
            //    $Icone = $("<i class='fas fa-envelope-open-text' style='position:relative'></i>");
            //}
            //else {
            var typeICone = "envelope"
            if (dataTemplate.presentation_mailing == "1") typeICone = "square-envelope"
            $Icone = $("<i class='fas fa-" + typeICone + "' style='position:relative'></i>");
            //}
            var $ssIcone = $("<i class='fas' style='position:absolute;bottom:-5px;right:-8px;opacity:1;font-size:90%;color:" + theme.backgroundcolorAccent + "'></i>")
            switch (parseInt(dataTemplate.id_type_classement)) {
                case 7: $ssIcone.addClass("fa-pen"); toolTip = "Email brouillon"; break; //brouillon
                    $ssIcone.css("font-size", "95%")
                case 8:
                    $ssIcone.addClass("fa-hourglass-half fa-shake"); toolTip = "Email en attente";
                    break; //envoi_attente
                case 9: case 13:
                    $ssIcone.addClass("fa-spinner fa-spin-pulse"); toolTip = "Email en cours";
                    if (dataTemplate.nb_error > 0) {
                        $("<i class='fas fa-triangle-exclamation' style='position:absolute;top:-2px;left:-4px;opacity:1;font-size:65%;color:red'></i>").appendTo($Icone)
                    }
                    break; //envoi_encours
                case 10:
                    $ssIcone.addClass("fa-paper-plane");
                    toolTip = "Email envoyé";
                    break; //envoi_envoye
                case 11:
                    $ssIcone.addClass("fa-triangle-exclamation");
                    $ssIcone.css("color", "red");
                    toolTip = "Email en erreur";
                    break; //envoi_envoye_erreur
                case 12: //envoi tracking
                    $ssIcone.addClass("fa-bullseye");
                    toolTip = "Email tracké";
                    break;
            }
            if ($ssIcone) $ssIcone.appendTo($Icone)
        }
        //$("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: $Icone, position: "bottom", contentTemplate: function (contentElement) { contentElement.text(toolTip) } })
        $Icone.attr("title", toolTip)
        return $Icone
    }

    this.mActionSaveAfter = function () {
        if (Me.objet.bddRef.msgEmailSms) Me.objet.bddRef.msgEmailSms.mGetData(true)
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();
    }

    this.mInitNewData = function (data) {
        var societe = Me.objet.bddRef.mGetArray("societe").filter(function (o) { return o.date_abandon == null })[0]
        data.id_societe = ((typeof societe == 'undefined') ? null : societe.id_societe)
    }

    this.mShowTransfere = function (funcFin) {
        Me.objet.bddRef.mAjaxCall({ "command": "transfereenvoi", id_com_email_envoi: objet.data.id_com_email_envoi }, function (data) {
            var newId = data.id_com_email_envoi
            var obj = Me.objet.bddRef.getObjet("com_email_envoi", newId)
            obj.mShowPopup();
            Me.objet.bddRef.triggerFunctionOnModifiedItemData("com_email_envoi", "new", obj.data)
            if (typeof funcFin != 'undefined') funcFin()
        })
    }

    this.mShowTransfereATous = function (funcFin) {
        Me.objet.bddRef.mAjaxCall({ "command": "transfereenvoiatous", id_com_email_envoi: objet.data.id_com_email_envoi }, function (data) {
            var newId = data.id_com_email_envoi
            var obj = Me.objet.bddRef.getObjet("com_email_envoi", newId)
            obj.mShowPopup();
            Me.objet.bddRef.triggerFunctionOnModifiedItemData("com_email_envoi", "new", obj.data)
            if (typeof funcFin != 'undefined') funcFin()
        })
    }

    this.mDisplayLstFile = function () {
        Me.objet.bddRef.mAjaxCall({ command: "getdataemailenvoi", id_com_email_envoi: objet.data.id_com_email_envoi }, function (data) {
            if (typeof data.lstFile == "undefined") data.lstFile = []
            if (data.lstfile.length > 0) $("<div/>").appendTo("body").dxCtrlViewer({
                bddCtrl: Me.objet.bddRef,
                value: data.lstFile,
                indexCourant: 0
            })
        })
    }

    this.mGetNomUsuelCourant = function () {
        var nomUsuel = objet.data.nom_usuel
        if (typeof nomUsuel == 'undefined' || nomUsuel == null || nomUsuel.length == 0) {
            var dataCompteEmail = Me.objet.bddRef.mGetArray("compte_email").filter(function (o) { return o.id_compte_email == objet.data.id_compte_email })[0]
            if (typeof dataCompteEmail == 'undefined') {
                nomUsuel = Me.objet.bddRef.getObjet("utilisateur", objet.data.id_utilisateur).objetMetier.mGetNomUsuelCourant()
            } else {
                nomUsuel = Me.objet.bddRef.getObjet(dataCompteEmail).objetMetier.mGetNomUsuelCourant()
            }
        }
        return nomUsuel
    }

    //this.contentTemplatePopup = function (contentElement, option) {
    //    contentElement.empty();
    //    if (objet.data.id_com_email_envoi == null) {
    //        Me.objet.bddRef.mAjaxCall({ command: "getdatasignature", id_compte_email: objet.data.id_compte_email, id_utilisateur: objet.data.id_utilisateur }, function (data) {
    //            if (typeof data.lstfile == "undefined") data.lstfile = []
    //            if (typeof option.lstfile != 'undefined') data.lstfile = data.lstfile.concat(option.lstfile)
    //            objet.data.nb_fichier_joint = data.lstfile.length
    //            objet.data.objet = data.objet
    //            mRempli()
    //        })
    //    }
    //    else {
    //        //Me.objet.bddRef.mAjaxCall({ command: "getdataemailenvoi", id_com_email_envoi: objet.data.id_com_email_envoi }, function (data) {
    //        //    if (typeof data.lstfile == "undefined") data.lstfile = []
    //        mRempli()
    //        //})
    //    }

    //    var dxCtrl = null
    //    option.onClose = function () {
    //        if (dxCtrl) dxCtrl.mStopSaveAuto()
    //    }
    //    function mRempli() {
    //        dxCtrl = $("<div style='height:100%;width:100%;'/>").appendTo(contentElement).dxCtrlContentEmailEnvoi({
    //            bddCtrl: Me.objet.bddRef,
    //            data: objet.data,
    //            toolbar:option.toolbar,
    //            //html: html,
    //            //urlhtml: urlhtml,
    //            //lstfile: lstfile,
    //            lstDestinataire: option.lstDestinataire
    //        }).dxCtrlContentEmailEnvoi("instance")
    //    }
    //}

    this.mGetItemTemplateHeight = function (type) {
        return ((type == "Détails") ? 87 : 35)
    }
    this.mGetNomFromTemplate = function (dataTemplate) {
        return dataTemplate.objet
    }
    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {
        if (typeof option == 'undefined') option = {}
        if (typeof option.hideStat == 'undefined') option.hideStat = false
        var $Table = $("<table style='table-layout:fixed;width:100%;height:100%;text-align:left;'/>").appendTo(contentElement) //rajout height:100%
        var $Tr = $("<tr/>").appendTo($Table)

        var $TdObjetBody = $("<td style='width:75%;overflow:hidden;text-overflow:ellipsis;padding:0 3px;'/>").appendTo($Tr)

        var bodyTxt = $("<div/>").html(dataTemplate.body_txt).text().replace(/\u00A0/g, '')
        var txtNomObjet = ""
        if (dataTemplate.nom == null || dataTemplate.nom.length == 0) { }
        else { txtNomObjet += dataTemplate.nom.decoupe() }
        if (dataTemplate.objet == null || dataTemplate.objet.length == 0) { txtNomObjet += "&nbsp;" }
        else { txtNomObjet += ((txtNomObjet.length > 0) ? " &bull; " : "") + dataTemplate.objet.decoupe() }
        if (type == "Détails") {
            $TdObjetBody.html(txtNomObjet)
            $TdObjetBody.css("font-weight", "500")
            $TdObjetBody.attr("title", txtNomObjet)
        } else {
            bodyTxt = bodyTxt.substring(0, 300)
            var $B = $("<b style='font-weight:500;'/>").appendTo($TdObjetBody)
            $B.html(txtNomObjet)
            $("<span> &bull; <i style='opacity:0.7;'>" + bodyTxt + "</i></span>").appendTo($TdObjetBody)
        }

        var $TdEmailDestinataire = $("<td style='width:25%;overflow:hidden;text-overflow:ellipsis;padding:0 3px;font-size:90%;'></td>").appendTo($Tr)
        var txt = ""
        if (dataTemplate.adremails != null) {
            dataTemplate.adremails.split("|!*|").forEach(function (item, idx) {
                if (txt.length > 0) txt += " &bull; "
                txt += "<u>" + item + "</u>"
                if (dataTemplate.nomusuels.split("|!*|")[idx].length > 0) {
                    txt += " [" + dataTemplate.nomusuels.split("|!*|")[idx] + "]"
                }
            })

            if (dataTemplate.nbdest > 1) txt = "(" + dataTemplate.nbdest + ") " + txt
            if (dataTemplate.adremails.split("|!*|").length < dataTemplate.nbdest) txt += " ..."
        }
        $TdEmailDestinataire.html(txt)
        $TdEmailDestinataire.attr("title", "<b>Destinataire" + ((dataTemplate.nbdest > 1) ? "s" : "") + ":</b><br/>" + txt)

        var $TdTaille = $("<td style='width:50px;font-size:90%;padding:0 3px;text-align:center;opacity:0.5;font-family:barlow condensed;'>" + dataTemplate.taille_octet.sizeFile(2) + "</td>").appendTo($Tr)

        var $TdFile = $("<td style='width:40px;text-align:center;padding:0 3px;' class='dx-theme-accent-as-text-color'></td>").appendTo($Tr)
        if (dataTemplate.nb_fichier_joint > 0) {
            $("<i class='fas fa-paperclip'></i><sup style='font-size:70%'>" + dataTemplate.nb_fichier_joint + "</sup>").appendTo($TdFile)
        }

        //if (type == "Détails" && dataTemplate.nb_fichier_joint > 0) {
        //    contentElement.css("padding-bottom", "0px")
        //    objet.bddRef.mAjaxCall({
        //        command: "getlstfilejointemailenvoi",
        //        id_com_email_envoi: dataTemplate.id
        //    }, function (data) {
        //        if (typeof data.lstFile == 'undefined' || data.lstFile.length == 0) { }
        //        else {
        //            $("<div/>").appendTo(contentElement).dxCtrlFichier2Document({
        //                bddCtrl: objet.bddRef,
        //                dataSource: data.lstFile,
        //                readOnly: true
        //            })
        //        }
        //    })
        //}

        var $TdUti = $("<td style='width:20px;padding:0 1px;height:1px;'/>").appendTo($Tr)
        $("<div style='width:18px;height:18px;border-radius:50%;'/>").appendTo($TdUti).dxCtrlImgSimpleStrConUti({
            bddCtrl: objet.bddRef,
            idTable: objet.bddRef.getObjet("utilisateur").mGetTable().id_table,
            id: dataTemplate.id_utilisateur,
            text: objet.bddRef.getObjet("utilisateur", dataTemplate.id_utilisateur).mGetLib1()
        })

        var $TdDest = $("<td style='width:20px;padding:0 1px;height:1px;'/>").appendTo($Tr)
        if (type == "Détails") {
            $TdDest.attr("rowspan", "2")
            $TdDest.css("width", "60px")
            $TdDest.css("padding", "5px")
        }
        switch (parseInt(dataTemplate.nbdest)) {
            case 0:
                $("<div style='width:100%;height:100%;border-radius:50%;' title='Aucun destinataire'/>").appendTo($TdDest).dxCtrlImgSimpleStrConUti({
                    bddCtrl: objet.bddRef,
                    icon1: "fas fa-at",
                    icon2: "",
                    text: ""
                })
                break;
            case 1:
                $("<div style='width:100%;height:100%;border-radius:50%;p' title='1 destinataire'/>").appendTo($TdDest).dxCtrlImgSimpleStrConUti({
                    bddCtrl: objet.bddRef,
                    icon1: ((dataTemplate.id_table_dest_envoi == null) ? "fas fa-at" : null),
                    idTable: dataTemplate.id_table_dest_envoi,
                    id: dataTemplate.id_dest_envoi,
                    text: dataTemplate.nom_usuel_envoi
                })
                $TdDest.addClass("state-hover-border-shadow")
                $TdDest.on("click", function (e) {
                    e.stopPropagation()
                    if (dataTemplate.id_table_dest_envoi != null) {
                        page.mAddPopupIdTableId(dataTemplate.id_table_dest_envoi, dataTemplate.id_dest_envoi)
                    } else {
                        objet.bddRef.mAjaxCall({ command: "getlstdestfromidtableid", id_table: dataTemplate.id_table_key, id: dataTemplate.id_key }, function (data) {
                            var lstData = ((typeof data.lst == 'undefined') ? [] : data.lst)
                            if (lstData.length == 1) {
                                var dataDest = objet.bddRef.getObjet("com_destinataire", lstData[0].id_com_destinataire).data
                                objet.bddRef.getObjet("com_destinataire").objetMetier.mCreateContactFromComDest($TdDest, dataDest, null, true)
                            }
                        })
                    }
                })
                break;
            default:
                var dxImg = $("<div style='width:100%;height:100%;border-radius:50%;' title='" + dataTemplate.nbdest + " destinataires'/>").appendTo($TdDest).dxCtrlImgSimpleStrConUti({
                    bddCtrl: objet.bddRef,
                    icon1: "fas fa-users",
                    icon2: "",
                    text: "",
                    count: dataTemplate.nbdest
                }).dxCtrlImgSimpleStrConUti("instance")
                if (type != "Détails") {
                    dxImg.element().css("height", "20px")
                    dxImg.element().find(".count").css({
                        "font-size": "50%",
                        "bottom": "-5px"
                    })
                    dxImg.element().attr("title", dataTemplate.nbdest + " destinataires")
                }
                if (objet.bddRef.utiCourant.id_utilisateur > 99999) {
                    $TdDest.addClass("state-hover-border-shadow")
                    $TdDest.on("click", function (e) {
                        e.stopPropagation()
                        objet.bddRef.mAjaxCall({ command: "getlstdestfromidtableid", id_table: dataTemplate.id_table_key, id: dataTemplate.id_key }, function (data) {
                            var lstData = ((typeof data.lst == 'undefined') ? [] : data.lst)
                            page.mAddPopupLst("Destinataires", function (contentElement) {
                                $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlPopupLstStrConTempo({
                                    bddCtrl: objet.bddRef,
                                    lstIdTableIdInclu: lstData
                                })
                            })
                        })
                    })
                }
                break;
        }

        if (type == "Détails") {
            if (dataTemplate.tracking == 1 && dataTemplate.date_envoi != null && !option.hideStat && parametre.isDesktop) {
                $TdReacGros = $("<td style='width:75px;padding-right:5px;height:1px;' rowspan='2'/>").appendTo($Tr)
                $("<div style='width:100%;height:100%;'/>").appendTo($TdReacGros).dxCtrlStatTaux({
                    bddCtrl: objet.bddRef,
                    dataTemplate: dataTemplate,
                    typeStat: "tx_vue_email",
                    heightMinReduit: 200
                })
                $TdReacGros = $("<td style='width:75px;padding-right:5px;height:1px;' rowspan='2'/>").appendTo($Tr)
                $("<div style='width:100%;height:100%;'/>").appendTo($TdReacGros).dxCtrlStatTaux({
                    bddCtrl: objet.bddRef,
                    dataTemplate: dataTemplate,
                    typeStat: "tx_click_email",
                    heightMinReduit: 200
                })
                $TdReacGros = $("<td style='width:75px;padding-right:5px;height:1px;' rowspan='2'/>").appendTo($Tr)
                $("<div style='width:100%;height:100%;'/>").appendTo($TdReacGros).dxCtrlStatTaux({
                    bddCtrl: objet.bddRef,
                    dataTemplate: dataTemplate,
                    typeStat: "tx_reactivite_email",
                    heightMinReduit: 200
                })
            }

            var $Tr2 = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:100%;padding:0 3px;white-space:normal;font-style:italic;font-size:90%;line-height:1.3;opacity:0.7;' colspan='5'></td>").appendTo($Tr2)
            var $Div = $("<div class='ellipsismultiligne3'></div>").appendTo($Td)
            $Div.text(bodyTxt.decoupe())
        }

    }
    this.itemTemplateGrillePlus = function (contentElement, dataPlus) {
        var smtpNom = ""
        switch (parseInt(dataPlus.id_type_smtp_encours)) {
            case 1: smtpNom = "<span style='color:green'>SMTP adresse email (" + dataPlus.id_type_smtp_encours + ")</span>"; break;
            case 2: smtpNom = "<span style='color:green'>SMTP " + parametre.nom + " emailing (" + dataPlus.id_type_smtp_encours + ")</span>"; break;
            case 3: case 9: smtpNom = "<span style='color:red'>SMTP dégradé (" + dataPlus.id_type_smtp_encours + ")</span>"; break;
            case 4: smtpNom = "<span style='color:orange'>SMTP " + parametre.nom + " quotidien (" + dataPlus.id_type_smtp_encours + ")</span>"; break;
            case 10: smtpNom = "<span style='color:green'>SMTP domaine dédié client (" + dataPlus.id_type_smtp_encours + ")</span>"; break;
            default: smtpNom = "<span style='color:gray'>SMTP type " + dataPlus.id_type_smtp_encours + " (" + dataPlus.id_type_smtp_encours + ")</span>"; break;
        }
        if (dataPlus.id_type_classement == "7") {
            //brouillon
            var $Span = $("<span style=''><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)
            $Span.attr("title", "Créé le " + dataPlus.dcr.toFrenchDateTime() + "")
        } else if (dataPlus.id_type_classement != "10" && dataPlus.id_type_classement != "12") {
            //envoi en cours
            var $Span = $("<span style=''><i class='fas fa-paper-plane dx-theme-accent-as-text-color' style='padding-right:3px;'></i><img src='" + parametre.urldispatch + "/img/jauge2.svg' style='width:12px;display:inline-block'/>en cours</span>").appendTo(contentElement)
            $Span.attr("title", "Envoi en cours" + "<br/>" + smtpNom)
        } else if (dataPlus.date_envoi) {
            //envoi fini
            var $Span = $("<span style=''><i class='fas fa-paper-plane dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.date_envoi.toDateIlya(true) + "</span>").appendTo(contentElement)
            $Span.attr("title", "Envoyé le " + dataPlus.date_envoi.toFrenchDateTime() + "<br/>" + smtpNom)
        } else {
            //envoi fini
            var $Span = $("<span style=''><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)
            $Span.attr("title", "Créé le " + dataPlus.dcr.toFrenchDateTime() + "<br/>" + smtpNom)
        }
        var $SpanClickVue = $("<span/>").appendTo(contentElement)
        if (dataPlus.last_date_vue != null) {
            var $S = $("<br/><span><i class='fas fa-eye dx-theme-accent-as-text-color' style='padding-right:3px;'></i>(" + dataPlus.nb_vue + ") " + dataPlus.last_date_vue.toDateIlya(true) + "</span>").appendTo($SpanClickVue)
            $S.attr("title", "Dernière vue le " + dataPlus.last_date_vue.toFrenchDateTime())
        }
        if (dataPlus.last_date_click != null) {
            var $S = $("<br/><span><i class='fas fa-arrow-pointer dx-theme-accent-as-text-color' style='padding-right:3px;'></i>(" + dataPlus.nb_click + ") " + dataPlus.last_date_click.toDateIlya(true) + "</span>").appendTo($SpanClickVue)
            $S.attr("title", "Dernier click le " + dataPlus.last_date_click.toFrenchDateTime())
        }
        //var dxTitle = $("<span/>").appendTo(contentElement).dxCtrlChartComEnvoiLigneResume({
        //    bddCtrl: objet.bddRef,
        //    dataPlus: dataPlus,
        //    update: true
        //}).dxCtrlChartComEnvoiLigneResume("instance")
    }

    this.itemTemplateCard = function (contentElement) {
        var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:1px;vertical-align:top;'/>").appendTo($Tr)
        objet.mGetIcone().appendTo($Td)
        var $Td = $("<td style='width:100%'/>").appendTo($Tr)
        var txt = ""
        if (objet.data.objet != null && objet.data.objet.length > 0) txt += objet.data.objet
        if (objet.data.body_txt != null && objet.data.body_txt.length > 0) txt += ((txt.length > 0) ? " ⚉ " : "") + "<span style='opacity:0.5;'/>" + objet.data.body_txt + "</span>"
        $Td.html(txt)
    }

    this.mSendImmediatement = function (funcOk) {
        objet.data.date_envoi = new Date()
        objet.data.id_type_classement = 13
        objet.mSave(function () {
            if (typeof funcOk != 'undefined') funcOk()
        })
    }

    this.mSend = function (funcOk) {
        if (Me.objet.bddRef.isDemo) {
            //on est en démo
            //le mail ne sera pas réellement envoyé
            //on prévient
            mNotify("Vous êtes dans un environnement de démo<br/>L'envoi de votre email sera simulé et celui-ci ne sera pas réellement envoyé", "warning", 6000)
        }
        if (objet.data.date_debut_envoi != null) { objet.data.date_envoi = objet.data.date_debut_envoi }
        else {
            objet.data.date_envoi = Me.objet.bddRef.getObjet(Me.objet.bddRef.utiCourant).objetMetier.mGetProchaineDateEnvoi(new Date(parametre.dateNow.getTime()))
            var dataCompteEmail = Me.objet.bddRef.mGetArray("compte_email").filter(function (o) { return o.id_compte_email == objet.data.id_compte_email })[0]
            if (dataCompteEmail.envoi_temporisation_mn != null) {
                debugger;
                objet.data.date_envoi.setMinutes(objet.data.date_envoi.getMinutes() + parseInt(dataCompteEmail.envoi_temporisation_mn))
            }
        }

        objet.data.id_type_classement = 9 //envoi_attente

        if ((new Date(objet.data.date_envoi)).addMinutes(-10) > parametre.dateNow) {
            //la date d'envoi est dans l'avenir
            //on met en attente
            objet.data.id_type_classement = 8
        }

        //if (diffdate(parametre.dateNow, objet.data.date_envoi, "s") >= 3) {
        //    //on a un envoi différé
        //    //objet.data.id_type_classement = 8 //envoi_attente
        //    notify.mShow({
        //        showTitle: false,
        //        width: 340,
        //        message: function (contentElement, popup) {
        //            contentElement.css("font-size", "100%")
        //            contentElement.css("padding-left", "10px")
        //            var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
        //            var $Tr = $("<tr/>").appendTo($Table)
        //            var $TdMessage = $("<td style='white-space:nowrap;padding-right:5px;text-align:right;'/>").appendTo($Tr)
        //            var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
        //            $("<div/>").appendTo($Td).dxCtrlButton({
        //                icon: "fas fa-xmark",
        //                txtTooltip: "Annuler l'envoi<br/>et remettre le message dans les brouillons",
        //                width: "100%",
        //                onClick: function (e) {
        //                    objet.data.date_envoi = null
        //                    objet.data.id_type_classement = 7
        //                    objet.mSave()
        //                    popup.hide()
        //                    mNotify("Votre email a été replace dans les brouillons", "warning", 1000)
        //                }
        //            })
        //            var $Td = $("<td style='width:1px'/>").appendTo($Tr)
        //            $("<div/>").appendTo($Td).dxCtrlButton({
        //                icon: "fas fa-paper-plane",
        //                txtTooltip: "Envoyer votre email immédiatement",
        //                icon2: "fas fa-arrow-right",
        //                width: "100%",
        //                onClick: function (e) {
        //                    objet.data.date_envoi = new Date(parametre.dateNow.getTime())
        //                    objet.mSaveChamp("date_envoi")
        //                    popup.hide()
        //                    mNotify("Votre email va être envoyé immédiatement", "success", 1000)
        //                }
        //            })
        //            function mDecompte() {
        //                if ($TdMessage.closest("body").length == 0 || objet.data.date_envoi == null) return
        //                $TdMessage.html("L'email sera envoyé dans<br/>" + (new Date()).decompte(objet.data.date_envoi))
        //                if (diffdate(parametre.dateNow, objet.data.date_envoi, "s") < 3) {
        //                    popup.hide()
        //                } else { window.setTimeout(function () { mDecompte() }, 1000) }
        //            }
        //            mDecompte()
        //        },
        //        tempoSeconde: 10
        //    })
        //}

        objet.data.nb_dest_envoye = 0
        objet.bddRef.mAjaxCall({ command: "save_nb_credit_message", type: "email", id_com: objet.cle(), nb_credit: objet.data.nb_credit_par_message }, function (data) {
            Me.objet.bddRef.objCptCli.objetMetier.mUseEmail(data.nbcredittouse)
            objet.mSave(function () {
                $(document).trigger('sendedEmailEvent', null);
                if (typeof funcOk != 'undefined') funcOk()
                if (Me.objet.bddRef.utiCourantParaJson.parametre_general.reponse_email_archive_email_recu) {
                    Me.objet.bddRef.mAjaxCall({
                        command: "getemailrecusourcesipasarchive",
                        id_com_email_envoi: objet.data.id_com_email_envoi
                    }, function (data) {
                        if (data.id_com_email_recu) {
                            if (!Me.objet.bddRef.utiCourantParaJson.parametre_general.jai_compris_reponse_email_archive_email_recu) {
                                messagePopup.mShow({
                                    bddCtrl: Me.objet.bddRef,
                                    titre: "Archivage automatique",
                                    message: function (contentElement, popup) {
                                        $("<div style='font-size:80%;'>Quand vous répondez à un email reçu, le mail reçu est automatiquement archivé quand vous envoyez votre réponse.</div>").appendTo(contentElement)
                                        $("<div style='font-size:80%;'>Vous pouvez modifier ce comportement dans le <b>menu utilisateur</b>→Paramètre→Email.</div>").appendTo(contentElement)
                                        var $A = $("<a href='javascript:void(0)' style='font-size:80%;'>Ne plus archiver les emails auxquels je réponds</a>").appendTo(contentElement)
                                        $A.on("click", function (e) {
                                            Me.objet.bddRef.utiCourantParaJson.parametre_general.reponse_email_archive_email_recu = false
                                            Me.objet.bddRef.mSaveParaJsonUtilisateur();
                                            popup.hide()
                                        })
                                        $("<br/>").appendTo(contentElement)
                                        $("<br/>").appendTo(contentElement)
                                        var $Div = $("<div style='text-align:right'></div>").appendTo(contentElement)
                                        var $A2 = $("<a href='javascript:void(0)' style='font-size:80%;'>J'ai compris</a>").appendTo($Div)
                                        $A2.attr("title", "J'ai compris le message.<br/>Ne plus afficher cette information.")
                                        $A2.on("click", function (e) {
                                            Me.objet.bddRef.utiCourantParaJson.parametre_general.jai_compris_reponse_email_archive_email_recu = true
                                            Me.objet.bddRef.mSaveParaJsonUtilisateur();
                                            popup.hide()
                                        })
                                    },
                                    tempoSeconde: 20
                                })
                            }
                            var obj = Me.objet.bddRef.getObjet("com_email_recu", data.id_com_email_recu)
                            obj.data.id_type_classement = 2
                            obj.mSaveChamp("id_type_classement")
                        }
                    })
                }
            })
        })
    }

    this.mGetDateEtLib = function (court) {
        var dateEnvoi = objet.data.date_envoi
        if (dateEnvoi == null) dateEnvoi = objet.data.dmo
        var result = { dat: "", lib: "", fini: false, canCancel: false, enCoursEnvoi: false, dateEnvoi: objet.data.date_envoi }
        switch (parseInt(objet.data.id_type_classement)) {
            case 7:
                result.lib = ((court) ? "" : "Créé ") + objet.data.dcr.toDateIlya(true, null, new Date()) + "";
                result.dat = "Créé le " + objet.data.dcr.toFrenchDateTime();
                break; //brouillon
            case 8:
                if (diffdate(new Date(), dateEnvoi) < 0) {
                    result.lib = ((court) ? "En crs envoi" : "En cours d'envoi");
                    result.dat = "En cours d'envoi"
                    result.fini = true
                    result.enCoursEnvoi = true
                } else {
                    result.lib = ((court) ? "" : "Sera envoyé dans ") + dateEnvoi.toDateIlya(true, true, new Date()) + "";
                    result.datdat = "Sera envoyé le " + dateEnvoi.toFrenchDateTime();
                    result.canCancel = true
                }
                break; //envoi attente
            case 9: case 13:
                result.lib = ((court) ? "" : "EN COURS D'ENVOI");
                result.dat = dateEnvoi.toFrenchDateTime();
                result.dat = "En cours d'envoi"
                break; //envoi_en_cours OU envoi_attente_immédiat
            case 10: case 12:
                result.lib = ((court) ? "" : "Envoyé ") + dateEnvoi.toDateIlya(true, null, new Date()) + "";
                result.dat = "Envoyé le " + dateEnvoi.toFrenchDateTime();
                break; //Envoyé //tracking
            case 11:
                result.lib = ((court) ? "" : "Essai d'envoi ") + objet.data.dcr.toDateIlya(true, null, new Date()) + "";
                result.dat = "Essai d'envoi le " + objet.data.dcr.toFrenchDateTime();
                break; //erreur
        }
        return result
    }

    this.isPopupFullScreen = true
    //this.mShowPopup = function (option) {
    //    if (typeof option == 'undefined') option = {}
    //    option.fullScreen = true
    //    page.mAddPopup(objet.data, option)
    //}
    this.contentTemplatePopup = function (contentElement, option) {
        contentElement.empty();
        if (objet.data.id_com_email_envoi == null) {
            Me.objet.bddRef.mAjaxCall({ command: "getdatasignature", id_compte_email: objet.data.id_compte_email, id_utilisateur: objet.data.id_utilisateur }, function (data) {
                if (typeof data.lstfile == "undefined") data.lstfile = []
                if (typeof option.lstfile != 'undefined') data.lstfile = data.lstfile.concat(option.lstfile)
                objet.data.nb_fichier_joint = data.lstfile.length
                objet.data.objet = data.objet
                mRempli()
            })
        }
        else {
            mRempli()
        }

        function mRempli() {
            //contentElement.css("box-sizing", "border-box")
            $("<div style='height:100%;width:100%;'/>").appendTo(contentElement).dxCtrlContentEmailEnvoi({
                bddCtrl: Me.objet.bddRef,
                data: objet.data,
                optionPopup: option,
                lstDestinataire: ((option != null && option.lstDestinataire != 'undefined') ? option.lstDestinataire : [])
            }).dxCtrlContentEmailEnvoi("instance")
        }
    }

    this.mGetDataNewEmail = function () {
        var dataCpteEmail = Me.objet.bddRef.getObjet(Me.objet.bddRef.utiCourant).objetMetier.mGetDataCompteEmailDefaut()
        if (typeof dataCpteEmail == 'undefined') {
            //on a aucune adresse email sur l'utilisateur
            $("<div/>").appendTo("body").dxCtrlPopupMessageButton({
                title: "Ajouter une adresse mail",
                width: 550,
                contentTemplate: function (contentElement) {
                    contentElement.css("padding-top", "4px")
                    contentElement.html("Vous n'avez aucune adresse email configurée sur votre compte.<br/>Voulez vous en créer une tout de suite ?")
                },
                lstButton: [{
                    text: "Oui",
                    func: function () { Me.objet.bddRef.getObjet("compte_email").objetMetier.mShowPopupNew() }
                }, {
                    text: "Non",
                    func: function () { }
                }]
            })
            return null
        } else {
            var obj = Me.objet.bddRef.getObjet(Me.objet.bddRef.getObjet("com_email_envoi").mGetNewData())
            obj.data.id_compte_email = dataCpteEmail.id_compte_email
            obj.data.email_expediteur = dataCpteEmail.adresse_email
            obj.data.id_utilisateur = Me.objet.bddRef.utiCourant.id_utilisateur
            obj.data.id_type_classement = 7
            return obj.data
        }
    }

    this.mShowNewEmail = function (isMailing, dataCpteEmail) {
        var data = Me.objet.mGetNewData()
        data.presentation_mailing = ((isMailing) ? "1" : "0")
        page.mAddPopup(data, {
            fullScreen: true,
            nomTable: "com_email_envoi",
            funcCreate: function (funcOk) {
                if (typeof isMailing == 'undefined') isMailing = false
                Me.objet.bddRef.getObjet("com_email_envoi").objetMetier.mCreateEmailBrouillon(
                    "", ((isMailing) ? '<html assistant2="1"><body></body></html>' : ""), [],
                    [],
                    null,
                    false, null, false, dataCpteEmail, isMailing, "", function (idComEmailEnvoi) {
                        funcOk(Me.objet.bddRef.getObjet("com_email_envoi", idComEmailEnvoi).data)
                        //page.mAddPopup(Me.objet.bddRef.getObjet("com_email_envoi", idComEmailEnvoi).data, { fullScreen: true })
                    })
            }
        })

    }
    this.mShowNewEmailBrouillon = function (objet, html, lstfile, lstdest, dataSignature, mergeField, idMergeField, forcerSurEmailAppli, dataCpteEmail, isMailing, funcEnd) {
        page.mAddPopup(Me.objet.mGetNewData(), {
            fullScreen: true,
            nomTable: "com_email_envoi",
            funcCreate: function (funcOk) {
                Me.mCreateEmailBrouillon(objet, html, lstfile, lstdest, dataSignature, mergeField, idMergeField, forcerSurEmailAppli, dataCpteEmail, isMailing, "", function (idComEmailEnvoi) {
                    var data = Me.objet.bddRef.getObjet("com_email_envoi", idComEmailEnvoi).data
                    funcOk(data)
                    if (typeof funcEnd != 'undefined') funcEnd(data)
                })
            }
        })
    }

    this.mCreateEmailBrouillon = function (objet, html, lstfile, lstdest, dataSignature, mergeField, idMergeField, forcerSurEmailAppli, dataCpteEmail, isMailing, htmlComplementBody = "", funcOk) {
        if (typeof dataCpteEmail == 'undefined' || dataCpteEmail == null) dataCpteEmail = ((Me.objet.bddRef.utiCourant == null) ? null : Me.objet.bddRef.getObjet(Me.objet.bddRef.utiCourant).objetMetier.mGetDataCompteEmailDefaut())
        if (!Me.objet.bddRef.baseAppli.para.email.can_create_message_email_without_compte && (typeof dataCpteEmail == 'undefined' || dataCpteEmail == null) && !forcerSurEmailAppli) {
            //on a aucune adresse email sur l'utilisateur
            $("<div/>").appendTo("body").dxCtrlPopupMessageButton({
                title: "Ajouter une adresse mail",
                width: 550,
                contentTemplate: function (contentElement) {
                    contentElement.css("padding-top", "4px")
                    contentElement.html("Vous n'avez aucune adresse email configurée sur votre compte.<br/>Voulez vous en créer une tout de suite ?")
                },
                lstButton: [{
                    text: "Oui",
                    func: function () { Me.objet.bddRef.getObjet("compte_email").objetMetier.mShowPopupNew() }
                }, {
                    text: "Non",
                    func: function () { }
                }]
            })
        } else {
            var lstFileSend = null
            if (typeof lstfile != 'undefined' && lstfile != null) {
                lstFileSend = []
                lstfile.forEach(function (nomFile) {
                    lstFileSend.push({ url: nomFile })
                })
            }
            if (typeof mergeField == 'undefined' || mergeField == null) mergeField = false
            if (typeof dataSignature == "undefined" || dataSignature == null) {
                if (dataCpteEmail == null) {
                    dataSignature = null
                } else {
                    var dataCpteEmailUti = Me.objet.bddRef.getObjet(dataCpteEmail).objetMetier.mGetDataCompteEmailUtilisateur()
                    if (typeof dataCpteEmailUti != 'undefined') {
                        if (typeof dataCpteEmailUti.data_signature == "undefined" || dataCpteEmailUti.data_signature == null) {
                            if (typeof Me.objet.bddRef.utiCourant.data_signature == "undefined" || Me.objet.bddRef.utiCourant.data_signature == null) {
                                dataSignature = null
                            } else {
                                dataSignature = Me.objet.bddRef.utiCourant.data_signature
                            }
                        } else {
                            dataSignature = dataCpteEmailUti.data_signature
                        }
                    } else { dataSignature = null }
                }
            }
            var nomUsuel = (dataCpteEmail ? Me.objet.bddRef.getObjet(dataCpteEmail).objetMetier.mGetNomUsuelCourant() : parametre.nom)
            if (typeof idMergeField == "undefined") idMergeField = null //champ complementaire pour le merge (exemple: id_booking)
            Me.objet.bddRef.mAjaxCall({
                command: "createemailbrouillon",
                email_expediteur: ((typeof dataCpteEmail == 'undefined' || dataCpteEmail == null) ? parametre.adresseEmailNePasRepondre : dataCpteEmail.adresse_email),
                nom_usuel: nomUsuel,
                objet: objet,
                html: html,
                lstfile: lstFileSend,
                is_mailing: ((isMailing) ? "1" : "0"),
                lstdest: lstdest,
                datasignature: dataSignature,
                mergefield: ((mergeField) ? "1" : "0"),
                idmergefield: idMergeField,
                html_complement_body: htmlComplementBody
            }, function (data) {
                Me.objet.bddRef.triggerFunctionOnModifiedItemData("com_email_envoi", "new", data.bddadd.com_email_envoi[0])
                if (typeof funcOk != 'undefined') funcOk(data.id_com_email_envoi)
            })
        }
    }

    this.mSendEmailTest = function (lstEmail, funcOk) {
        //on duplik le mail
        objet.bddRef.mAjaxCall({ command: "duplikemailenvoi", id_com_email_envoi: objet.data.id_com_email_envoi, avec_destinataire: "0", test: "1" }, function (data) {
            //on rajoute les destinataires
            var idComEmailEnvoiDuplik = data.id_com_email_envoi
            var objs = objet.bddRef.getObjets()
            lstEmail.forEach(function (adresseEmail) {
                var newDataComDest = objet.bddRef.getObjet("com_destinataire").mGetNewData()
                newDataComDest.id_type_destinataire = 1
                newDataComDest.id_table_com = objet.bddRef.table.mGetItemFromNom("com_email_envoi").id_table
                newDataComDest.id_com = idComEmailEnvoiDuplik
                newDataComDest.id_table_destinataire = null
                newDataComDest.id_destinataire = null
                newDataComDest.adresse_email = adresseEmail
                objs.mAddData([newDataComDest], "save")
            })
            objs.mSave(function (data) {
                var objComEmailEnvoiDuplik = objet.bddRef.getObjet("com_email_envoi", idComEmailEnvoiDuplik)

                objComEmailEnvoiDuplik.data.date_envoi = parametre.dateNow
                objComEmailEnvoiDuplik.data.id_type_classement = 13
                objComEmailEnvoiDuplik.data.ignore_attente_compte_email = "1"
                objComEmailEnvoiDuplik.mSave(function (data) {
                    //on attend que l'envoi soit fait pour supprimer le mail à la fin
                    mVerifTestEmail()

                    function mVerifTestEmail() {
                        var objComEmailEnvoiDuplik = objet.bddRef.getObjet("com_email_envoi", idComEmailEnvoiDuplik)
                        if (objComEmailEnvoiDuplik.data.id_type_classement == 10 || objComEmailEnvoiDuplik.data.id_type_classement == 12) {
                            //l'email de test a été envoyé
                            //objComEmailEnvoiDuplik.mDelDataDefinitif(function () { funcOk() })
                            funcOk()
                        } else {
                            //l'email est en attente d'envoi
                            window.setTimeout(function () { mVerifTestEmail() }, 1000)
                        }
                    }
                })
            })
        })
    }

    this.mGetResultSpamAssassin = function (funcOk) {
        var identifiantMailTester = "sylo-" + objet.bddRef.utiCourant.id_utilisateur + "_" + (new Date()).getTime()
        var EmailTester = "" + identifiantMailTester + "@mail-tester.com"
        this.mSendEmailTest([EmailTester], function () {
            mGetResult()
            function mGetResult() {
                $.getJSON("https://www.mail-tester.com/" + identifiantMailTester + "&format=json", function (data) {
                    if (data.status == false) {
                        window.setTimeout(function () { mGetResult(); }, 1000)
                        return;
                    }
                    funcOk(data)
                });
            }
        })
    }

    this.mGetPopupPositionWidthHeight = function () {
        if (objet.data.presentation_mailing == "1") {
            return {
                width: "calc(100% - 60px)",
                maxWidth: "calc(100% - 60px)",
                height: "calc(100% - 90px)",
                maxHeight: "calc(100% - 50px)",
                position: {
                    my: "right top",
                    at: "right top",
                    of: "body",
                    offset: { x: -30, y: 65 }
                }
            }
        } else {
            return {
                width: "650",
                maxWidth: "calc(100% - 60px)",
                height: "750",
                maxHeight: "calc(100% - 50px)",
                position: {
                    my: "right bottom",
                    at: "right bottom",
                    of: "body",
                    offset: { x: -50, y: -25 }
                }
            }
        }
    }
    this.mGetDisplayInPopup = function (newValue) {
        var nomParaJson = "dataDisplayInPopup_" + ((objet.data.presentation_mailing == "1") ? "mailing_" : "") + objet.mGetTable().nom
        var valDefault = ((objet.data.presentation_mailing == "1") ? false : true)
        if (typeof objet.bddRef.utiCourantParaJson[nomParaJson] == 'undefined') {
            objet.bddRef.utiCourantParaJson[nomParaJson] = valDefault
        }
        if (typeof newValue != 'undefined') {
            objet.bddRef.utiCourantParaJson[nomParaJson] = newValue
            objet.bddRef.mSaveParaJsonUtilisateur();
        }
        return objet.bddRef.utiCourantParaJson[nomParaJson]
    }

    this.mPasseEnMailingFromPopup = function () {
        //window.mConfirmPopup = function (textHtml, onConfirm, textBtOk, onCancel, textBtCancel, onHiding, showTitle = true) {
        mConfirmPopup("<div style='text-align:center;'>" +
            "<b style='font-size:130%;'>Votre email va basculer en mode emailing.</b><br/><br/>" +
            "Il sera automatiquement fermé puis rouvert dans l’interface dédiée.<br/><br/>" +
            "Le message sera enregistré dans les brouillons emailing, <b>sans être envoyé</b>.<br/>" +
            "<div style='opacity:0.5;'><i>(Les emailings emails se trouve dans la page emails dans l'onglet emailing en bas à gauche)</i></div><br/> " +
            "Prenez le temps de vérifier l’intégralité de votre contenu,<br/>puis cliquez sur l’onglet <b>Envoyer</b> pour démarrer l’envoi de votre email.<br/><br/></div>",
            function () {
                page.mRemovePopup(objet.data, function () {
                    objet.data.presentation_mailing = "1"
                    objet.data.tracking = "1"
                    objet.data.heberger_image = "1"
                    objet.mSave(function (data) {
                        page.mAddPopup(objet.data)
                        mNotify("Votre message est maintenant classé dans les brouillons de l'onglet emailing", "success", 15000)
                    })
                })
            },
            "Passer en mailing",
            function () { },
            "Annuler", null, false)
    }

}